import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { useI18n } from 'i18n';
import { TepRelevance } from 'constants/tep';
import SelectPicker from 'core/react/general/form/SelectPicker';
import { tepHistoryReportSelector } from 'core/redux/selectors/reports';

interface ITypePickerProps {
  disabled: boolean;
  value: string;
  onChange: (value: string) => void;
}

const OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Valid TEP', value: TepRelevance.Valid },
  { label: 'Expired TEP', value: TepRelevance.Expired },
];

export const TypePicker: FC<ITypePickerProps> = (props) => {
  const { disabled, value, onChange } = props;

  const { f } = useI18n();

  const { parameters } = useSelector(tepHistoryReportSelector);

  return (
    <div className="event-type-picker">
      <SelectPicker
        data={OPTIONS}
        value={value || parameters?.type}
        cleanable={false}
        searchable={false}
        onChange={onChange}
        placeholder={f('select option')}
        label={f('Select Type')}
        disabled={disabled}
      />
    </div>
  );
};
